<script>
import { Bar } from 'vue-chartjs'
import moment from 'moment'
export default {
    extends: Bar,
    data() {
        var datez = _.sortBy(_.values(_.mapValues(this.properties, 'date')));
        var labelz = _.map(datez, function(d) { return moment(d).format('D.M.YYYY'); });
        var dates = this.properties;
        var devsdict = _.keys(this.devices);
        var labels = dates;
        var that = this;
        var inspectiony = _.groupBy(_.flatten(_.values(this.properties)), 'inspection_id');
        var inspectionz = _.groupBy(_.flatten(_.values( _.pick(this.properties, devsdict))), 'inspection_id');
        var series = _.keys(inspectiony)
        var inspdict = _.keyBy(this.inspections, 'id');
        return {
            chartData: {
                datasets: [{
                        label: this.$t('routine_analyses.graphs.average_for_inspection'),
                        data: _.map(series, (c) => { return _.reduce(_.values(_.mapValues(inspectionz[c], 'conditions')), function(a,b){return a+b;}, 0.0) / (inspectionz[c] || [null]).length }),
                        fill: false,
                        borderColor: that.color,
                        backgroundColor: that.color,
                        borderWidth: 1
                 }],
                 labels: _.map(_.keys(inspectiony), (inspid)=>{
                    if(!_.isUndefined(inspdict[inspid])){
                     return moment(inspdict[inspid].date).format('D.M.YYYY');
                    }else{
                        return moment(_.first(inspectiony[inspid]).date).format('D.M.YYYY');
                    }
                })
            },
            options: {
                scales: {
                    yAxes: [{
                       ticks: {
                            stepSize: 1,
                            beginAtZero: true,
                            max: 4,
                            min: 0
                        },
                        gridLines: {
                            display: true
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            stepSize: 1,
                            beginAtZero: true,
                            max: 4,
                            min: 0
                        },
                        gridLines: {
                            display: false
                        }
                    }]
                },
                legend: {
                    display: false
                },
                spanGaps: true,
                responsive: false,
                maintainAspectRatio: false
            }
        }
    },
    props: {
        inspections: Array,
        properties: [Array, Object],
        devices: Object,
        color: String
    },
    mounted() {
        this.renderChart(this.chartData, this.options)
    }
}
</script>